import { addContact, hasContactListFeature, removeContact } from './contactList';
import { featureFlag } from './featureFlag';
import { getRiskManagementLastConsultationsMock } from './riskManagementLastConsultations';
import { searchTruckerProfile } from './searchTrucker';
import { tracking } from './tracking';
import { truckerProfile } from './truckerProfile';

const handlers = [
  ...searchTruckerProfile,
  ...truckerProfile,
  ...addContact,
  ...removeContact,
  ...hasContactListFeature,
  ...getRiskManagementLastConsultationsMock,
  ...featureFlag,
  ...tracking,
];

export { handlers };
